var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQliro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,17.3c-10.1-0.1-20.2-0.1-30.3,0c-7.3,0.1-13.7,5.9-14.4,13.1c-0.9,8.8,6,16.3,14.9,16.3c2.5,0,5.1,0,7.6,0 c0.8,0,1.4,0.2,2,0.8c1.5,1.5,3.1,3.1,4.6,4.6c0.3,0.3,0.7,0.5,1.1,0.5c3.5,0,6.9,0,10.4,0c0.2,0,0.4,0,0.7-0.1 c-0.3-0.3-0.5-0.5-0.7-0.7c-3.6-3.6-7.2-7.1-10.8-10.7c-2.2-2.2-4.8-3.3-7.9-3.3c-2.4,0-4.9,0-7.3,0c-3.9,0-6.7-3.7-5.7-7.4 c0.7-2.7,3-4.4,5.9-4.4c4.4,0,8.8,0,13.2,0c5.3,0,10.6,0,15.9,0c1.3,0,2.5,0.2,3.6,0.9c2.3,1.5,3.3,4.1,2.5,6.6s-3,4.2-5.7,4.2 c-4.3,0-8.6,0-12.9,0c-0.3,0-0.6,0-1,0c0.8,0.6,1.5,1.1,2.1,1.6c2.3,2.2,4.5,4.4,6.8,6.7c0.4,0.4,0.8,0.6,1.4,0.6c1.3,0,2.5,0,3.8,0 c2.3,0,4.5-0.5,6.5-1.5c6.1-3,9.3-9.9,7.8-16.6C62.8,22.2,56.7,17.4,50,17.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQliro);
export default __webpack_public_path__ + "static/media/qliro.a2f2474ff17fcafb0019f0cf5e0de6c6.svg";
export { ForwardRef as ReactComponent };